export const InstagramIcon = () => (
  <div className="h-4 w-4">
    <img src="/instagram.svg" alt="Instagram" />
  </div>
);
